import { Col, Row } from 'react-bootstrap';
import { $list, $view } from 'signals/global.signals';
import { formatMoneyShorthand } from 'utils/formatMoney';
import { calculateTotalPortfolioRaise, calculateTotalPortfolioCommitted } from './_helpers/founderRoomsListUtils';

const FounderPortfolioHighlights = () => (
  <Row className="mb-40">
    <Col sm={4} className="d-flex justify-content-center">
      <div className="border border-gray-400 rounded p-16 bg-gray-900 text-center w-100">
        <div className="text-muted">Total Rooms</div>
        <div>
          {$view.value.isLoading ? (
            <span className="lead text-muted fw-bold">--</span>
          ) : (
            <span className="lead text-success fw-bold">
              {$list.value.data?.length || 0}
            </span>
          )}
        </div>
      </div>
    </Col>
    <Col sm={4} className="d-flex justify-content-center">
      <div className="border border-gray-400 rounded p-16 bg-gray-900 text-center w-100">
        <div className="text-muted">Total Raise</div>
        <div>
          {$view.value.isLoading ? (
            <span className="lead text-muted fw-bold">--</span>
          ) : (
            <span className="lead text-success fw-bold">
              {formatMoneyShorthand(calculateTotalPortfolioRaise($list.value.data || []))}
            </span>
          )}
        </div>
      </div>
    </Col>
    <Col sm={4} className="d-flex justify-content-center">
      <div className="border border-gray-400 rounded p-16 bg-gray-900 text-center w-100">
        <div className="text-muted">Total Revenue</div>
        <div>
          {$view.value.isLoading ? (
            <span className="lead text-muted fw-bold">--</span>
          ) : (
            <span className="lead text-success fw-bold">
              {formatMoneyShorthand(calculateTotalPortfolioCommitted($list.value.data || []))}
            </span>
          )}
        </div>
      </div>
    </Col>
  </Row>
);

export default FounderPortfolioHighlights;
